import { API } from '@aws-amplify/api';

export interface ReassignBracketingTestInput {
  alphaId: string;
  subject: string;
}

export interface ReassignBracketingTestOutput {
  success: boolean;
  assignmentId: string;
  testLink: string;
  bracketingAssignmentId: number;
  testAssignmentId: number;
}

export async function reassignBracketingTest(
  input: ReassignBracketingTestInput
): Promise<ReassignBracketingTestOutput> {
  const apiName = process.env.NEXT_PUBLIC_LEARNING_API_NAME!;
  const path = 'edulastic/bracketing/reassign-test';
  const myInit = {
    queryStringParameters: {},
    body: input,
  };
  return await API.post(apiName, path, myInit);
}
